var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg400Error(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "190px",
    height: "158px",
    viewBox: "0 0 190 158",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 31") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "grids-GUI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SearchResults_\"NORESULTS\"",
    transform: "translate(-551.000000, -228.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-31",
    transform: "translate(518.000000, 185.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "blob-shape-(10)",
    transform: "translate(122.500000, 121.000000) rotate(-60.000000) translate(-122.500000, -121.000000) translate(35.000000, 31.000000)",
    fill: "#005D7D",
    fillOpacity: 0.1,
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.895709,30.9142012 C143.960747,43.0339461 156.441871,53.3284283 164.616643,67.6019834 C172.754921,81.8755384 176.586845,100.128166 173.119866,117.614184 C169.652887,135.100202 158.923499,151.856114 143.960747,164.267901 C128.9615,176.679688 109.728889,184.74735 96.7368414,176.132109 C83.7812878,167.516869 77.0662967,142.218726 61.2641708,130.062476 C45.4620448,117.906226 20.6092787,118.928373 8.96752771,109.437007 C-2.63772874,99.9456401 -1.03196998,79.9407599 5.39106503,61.9071634 C11.8505946,43.873567 23.0544113,27.8112544 38.0536579,16.3120988 C53.0164099,4.81294318 71.7745917,-2.12305545 87.9416628,1.38144912 C104.145228,4.88595369 117.794178,18.7944562 130.895709,30.9142012 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-30",
    transform: "translate(66.000000, 72.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.06214689,0 L149.187853,0 C153.088169,-7.16476431e-16 156.25,3.16183086 156.25,7.06214689 L156.25,91.8079096 L0,91.8079096 L0,7.06214689 C-1.36582937e-15,3.16183086 3.16183086,-4.61259409e-15 7.06214689,0 Z",
    id: "Rectangle",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F4F4F4",
    x: 1.41242938,
    y: 9.88700565,
    width: 153.248588,
    height: 80.3319209
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.706214689,90.3954802 L155.367232,90.3954802 L155.367232,6.3559322 C155.367232,3.23567938 152.837767,0.706214689 149.717514,0.706214689 L5.64971751,0.706214689 C2.91949629,0.706214689 0.706214689,2.91949629 0.706214689,5.64971751 L0.706214689,90.3954802 Z",
    id: "Rectangle",
    stroke: "#363639",
    strokeWidth: 1.41242938
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#D8D8D8",
    cx: 7.76836158,
    cy: 4.94350282,
    r: 1.41242938
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-9",
    fill: "#D8D8D8",
    cx: 12.0056497,
    cy: 4.94350282,
    r: 1.41242938
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-10",
    fill: "#D8D8D8",
    cx: 16.2429379,
    cy: 4.94350282,
    r: 1.41242938
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#363639",
    x: 0,
    y: 8.47457627,
    width: 156.073446,
    height: 1.41242938
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeOpacity: 0.25,
    stroke: "#363639",
    strokeWidth: 1.41242938,
    fill: "#FFFFFF",
    x: 7.76836158,
    y: 16.2429379,
    width: 140.536723,
    height: 19.7740113,
    rx: 2.82485876
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(12.005650, 20.480226)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-26",
    transform: "translate(0.000000, 4.237288)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#D8D8D8",
    cx: 0.706214689,
    cy: 6.3559322,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-13",
    fill: "#D8D8D8",
    cx: 6.3559322,
    cy: 6.3559322,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-12",
    fill: "#D8D8D8",
    cx: 3.53107345,
    cy: 6.3559322,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-14",
    fill: "#D8D8D8",
    cx: 9.18079096,
    cy: 6.3559322,
    r: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-55",
    fillOpacity: 0.25,
    fill: "#363639",
    x: 0,
    y: 0,
    width: 53.6723164,
    height: 1.41242938,
    rx: 0.706214689
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-58",
    fillOpacity: 0.25,
    fill: "#363639",
    x: 0,
    y: 2.82485876,
    width: 38.8418079,
    height: 1.41242938,
    rx: 0.706214689
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0.25,
    fill: "#363639",
    x: 0,
    y: 0,
    width: 66.3841808,
    height: 2.82485876,
    rx: 1.41242938
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-47",
    strokeOpacity: 0.25,
    stroke: "#363639",
    strokeWidth: 1.41242938,
    fill: "#FFFFFF",
    x: 7.76836158,
    y: 40.2542373,
    width: 140.536723,
    height: 19.7740113,
    rx: 2.82485876
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-48",
    strokeOpacity: 0.25,
    stroke: "#363639",
    strokeWidth: 1.41242938,
    fill: "#FFFFFF",
    x: 7.76836158,
    y: 64.2655367,
    width: 140.536723,
    height: 19.7740113,
    rx: 2.82485876
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0.25,
    fill: "#363639",
    x: 117.937853,
    y: 16.9491525,
    width: 1.41242938,
    height: 18.3615819
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-49",
    fillOpacity: 0.25,
    fill: "#363639",
    x: 117.937853,
    y: 40.960452,
    width: 1.41242938,
    height: 18.3615819
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-50",
    fillOpacity: 0.25,
    fill: "#363639",
    x: 117.937853,
    y: 64.9717514,
    width: 1.41242938,
    height: 18.3615819
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeOpacity: 0.25,
    stroke: "#363639",
    strokeWidth: 1.41242938,
    x: 122.881356,
    y: 27.5423729,
    width: 19.7740113,
    height: 4.23728814,
    rx: 0.706214689
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-51",
    strokeOpacity: 0.25,
    stroke: "#363639",
    strokeWidth: 1.41242938,
    x: 122.881356,
    y: 51.5536723,
    width: 19.7740113,
    height: 4.23728814,
    rx: 0.706214689
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-52",
    strokeOpacity: 0.25,
    stroke: "#363639",
    strokeWidth: 1.41242938,
    x: 122.881356,
    y: 75.5649718,
    width: 19.7740113,
    height: 4.23728814,
    rx: 0.706214689
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-27-Copy",
    transform: "translate(12.005650, 44.491525)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-26",
    transform: "translate(0.000000, 4.237288)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#D8D8D8",
    cx: 0.706214689,
    cy: 6.3559322,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-13",
    fill: "#D8D8D8",
    cx: 6.3559322,
    cy: 6.3559322,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-12",
    fill: "#D8D8D8",
    cx: 3.53107345,
    cy: 6.3559322,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-14",
    fill: "#D8D8D8",
    cx: 9.18079096,
    cy: 6.3559322,
    r: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-55",
    fillOpacity: 0.25,
    fill: "#363639",
    x: 0,
    y: 0,
    width: 53.6723164,
    height: 1.41242938,
    rx: 0.706214689
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-58",
    fillOpacity: 0.25,
    fill: "#363639",
    x: 0,
    y: 2.82485876,
    width: 38.8418079,
    height: 1.41242938,
    rx: 0.706214689
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0.25,
    fill: "#363639",
    x: 0,
    y: 0,
    width: 66.3841808,
    height: 2.82485876,
    rx: 1.41242938
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-27-Copy-2",
    transform: "translate(12.005650, 68.502825)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-26",
    transform: "translate(0.000000, 4.237288)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#D8D8D8",
    cx: 0.706214689,
    cy: 6.3559322,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-13",
    fill: "#D8D8D8",
    cx: 6.3559322,
    cy: 6.3559322,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-12",
    fill: "#D8D8D8",
    cx: 3.53107345,
    cy: 6.3559322,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-14",
    fill: "#D8D8D8",
    cx: 9.18079096,
    cy: 6.3559322,
    r: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-55",
    fillOpacity: 0.25,
    fill: "#363639",
    x: 0,
    y: 0,
    width: 53.6723164,
    height: 1.41242938,
    rx: 0.706214689
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-58",
    fillOpacity: 0.25,
    fill: "#363639",
    x: 0,
    y: 2.82485876,
    width: 38.8418079,
    height: 1.41242938,
    rx: 0.706214689
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0.25,
    fill: "#363639",
    x: 0,
    y: 0,
    width: 66.3841808,
    height: 2.82485876,
    rx: 1.41242938
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(124.023470, 35.551610) rotate(-30.000000) translate(-124.023470, -35.551610) translate(107.523470, 4.051610)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillOpacity: 0.2,
    fill: "#005D7D",
    cx: 16.2429379,
    cy: 16.2429379,
    r: 13.4180791
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1242938,32.3489552 C6.15461511,31.3108045 0,24.4956149 0,16.2429379 C0,7.27221098 7.27221098,0 16.2429379,0 C25.2136647,0 32.4858757,7.27221098 32.4858757,16.2429379 C32.4858757,24.4956149 26.3312606,31.3108045 18.3615819,32.3489552 L18.3615819,38.8418079 L14.1242938,38.8418079 L14.1242938,32.3489552 Z M16.2429379,28.9548023 C23.2635067,28.9548023 28.9548023,23.2635067 28.9548023,16.2429379 C28.9548023,9.222369 23.2635067,3.53107345 16.2429379,3.53107345 C9.222369,3.53107345 3.53107345,9.222369 3.53107345,16.2429379 C3.53107345,23.2635067 9.222369,28.9548023 16.2429379,28.9548023 Z",
    id: "Combined-Shape",
    stroke: "#363639",
    strokeWidth: 1.41242938,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7118644,38.8418079 L12.7118644,57.9096045 C12.7118644,59.8597625 14.2927798,61.440678 16.2429379,61.440678 C18.1930959,61.440678 19.7740113,59.8597625 19.7740113,57.9096045 L19.7740113,38.8418079 L12.7118644,38.8418079 Z",
    id: "Rectangle",
    stroke: "#363639",
    strokeWidth: 1.41242938,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#363639",
    strokeWidth: 0.78125,
    fill: "#D8D8D8",
    x: 13.1024894,
    y: 55.4753708,
    width: 6.28089689,
    height: 1
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg400Error);
export default __webpack_public_path__ + "static/media/400-error.59292cbe08d07ca6c04fd802d991940f.svg";
export { ForwardRef as ReactComponent };